<template>
	<section class="vocPrint">
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters"  size="mini">
				<el-form-item label="项目名称">
					<el-select v-model="filters.projectId" @change="getDevices" filterable>
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option >
					</el-select>
				</el-form-item>
				<el-form-item label="点位名称" >
					<el-select v-model="filters.mn" filterable>
						<el-option
							v-for="item in devices"
							:label="item.name"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="设备编码"  v-if="type==0">
					<el-select v-model="filters.mn" filterable>
						<el-option
							v-for="item in devices"
							:label="item.mnCode"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="时间范围">
					<el-date-picker
						v-model="filters.time" type="datetimerange" :picker-options="pickerOptions"  unlink-panels	range-separator="至"  start-placeholder="开始日期"  end-placeholder="结束日期"  align="right">
					</el-date-picker>
				</el-form-item>
				
				<el-form-item>
					<el-button type="primary" v-on:click="getDataList()">查询</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<div class="time_con">
		<!-- 视频播放器 -->
		<div class="video_fl">
	
			<div class="video_content" ref="dplayers" v-show="isshows == false"></div>
			<div class="schibtn"  	@click="BubblePlay()"  @keyup="CanEvents($event)" 	tabindex="0" 	ref="CanEvent"> 
				<canvas class="canvasTriangle_fl" ref="canvasTriangle" :width="dpWidth" :height="dpHeight"></canvas>
			</div>
			
			<div v-show="isshows == true" class="video_url_fl">
			<span class="video_url_text">
				暂无数据
			</span>
			</div>
		</div>
	
		<!-- 时间轴筛选器 -->
		<div class="tisp_time">
			<div v-show="tispT">
			<span class="tisp_fl_text">
				<span class="tisp_btn">{{CenteTime}}</span>
				<i class="el-icon-caret-bottom"></i>
			</span>
	
			<span class="tisp_fl_D" v-show="isDTime" :style="DTimestyle()">
				<span class="tisp_btn">{{DTime}}</span>
				<i class="el-icon-caret-bottom"></i>
			</span>
			</div>
	
		</div>
	
		<!-- 时间轴 -->
		<div class="canvas_fl" ref="canvasf">
			<span class="canvas_fl_time">
			<canvas ref="canvas" id="timeline" :width="Cwidth" :height="Cheight" style="border-top:0.1vmin solid #c8c8c8; cursor: pointer;background-color: #f3f3f3; z-index:66;" ></canvas>
			<span class="canvas_fl_S">
				<span class="timeS timeS_url" :style="setHeight()"></span>
				<span class="timeN timeN_url" :style="setHeight()"></span> 
				<button class="prev prev_fl" @click="jumpTime('prev',$event)" @mouseenter="enterE" @mouseleave="leaveE" :disabled="disabledP">
				<i class="el-icon-arrow-left"></i>
				</button>
				<button class="Next Next_fl" @click="jumpTime('next',$event)" @mouseenter="enterE" @mouseleave="leaveE" :disabled="disabledN">
				<i class="el-icon-arrow-right"></i>
				</button>
			</span>
			</span>
			<span class="widthc" ref="widthc"></span>
		</div>
	
		<!-- 列表视频选择 -->
		<div v-if="ListVideoShow == true" class="list_fl">
	
			<span ref="defDL" v-for="(item,index) in TimeList" :key="index" class="defDl_fl">
	
				<span v-if="item.length > 0">
				<span class="defdl_text">{{TimeList[index].length}}个视频</span>
	
				<video class="video_url_card" v-if="item[0].url != ''" :src="item[0].url" @click="reVio('1',TimeList[index],index)" ></video>
				<div class="video_url_card_text" v-else @click="reVio('1',TimeList[index],index)">音频</div>
	
				<span class="video_url_card_shadow"></span>
				<span class="video_url_card_shadowtow"></span>  
				</span>
				
			</span>
	
		</div>
	
		<!-- 列表显示 -->
		<div v-if="ListVideoShow == false" class="listShow">
			<div>
			<i class="el-icon-arrow-left icons" @click="reVio('2')"></i>
			列表
			</div>
			<div class="viderlist"> 
			<span v-for="(item,index) in videoLists" :key="index" class="videoItem">
	
				<span class="duration_text">"{{item.duration}}"</span>
				
				<video v-if="item.url != ''" :class="setVC(numVideoIndex,index,item.url)" :src="item.url" @click="reVio('3',item,index,item.wav_info)" ></video>
				<div v-else :src="item.wav_info" :class="setVT(numVideoIndex,index,item.wav_info,type)"  @click="reVio('3',item,index,item.wav_info)">音频</div>
	
			</span>
			</div>
		</div>
		
		<!-- 分类、图表 -->
		<div class="tisp_fl" v-if="iconP">
	
			<div class="tisp_fl_bg">
	
			<div class="text_bg">
				<span>当前声强：
				<span class="text_color text_bor">
					<span class="text_font">{{DBtext}}</span>
					<span class="text_wilte">dB</span>
				</span>
	
				</span>
			</div>
	
			<div class="text_bg">
				<span >声强峰值：</span>
				<span>{{maxDB}}</span>
			</div>
	
			<div class="text_bg">
				<span>声<span class="shi_t">纹：</span></span>
	
				<span class="text_bg_center">
				<el-tooltip effect="dark" :content="Sevent + '(' + Perc + '%)'" placement="top-start" popper-class="tip_class">
					<span class="Sevent_text">{{Sevent}} ({{Perc}}%)</span> 
				</el-tooltip>
				</span>
				
			</div>
			</div>
	
			<bars :Bars="Bars" :rotateBar="rotateBar" :static="barStatic" :curtime="curTime"  :emitpielist="emitpieList"/>  
		</div>
		
		<!-- 音频 -->
		<div v-show="iswfer" class="audiofer_fl">
			<audio :src="urls" ref="audios" controls></audio>
		</div>
	
		<!-- 视频列表 -->
		<el-dialog title="列表" :visible.sync="dialogVisible" :before-close="handleClose">
			<div v-if="isshow == 16"></div>
		</el-dialog>
	
		<el-dialog :title="titleti" :visible.sync="istitleti" width="80%" top="2vh" :before-close="handleClose">
			<iframe :src="iframeUrl" frameborder="0" width="100%" height="550px"></iframe>
		</el-dialog>
	
		</div>
	</section>
  </template>
  
  <script>
  import DPlayer from 'dplayer'
  import bars from '../../components/MyChart/FuXiBar.vue'

  import { getProjects,getDevicesByProjectId,getVoiceprintRecognitionList} from '../../api/api';
  import {formatDate} from '../../../static/fun.js';
  
  export default {
	data() {
	  const self = this
	  return {
		filters: {
			projectId:"",
			mn:"",
			time:''
		},
		pickerOptions: {
			shortcuts: [{
				text: '最近一天',
				onClick(picker) {
				const end = new Date();
				const start = new Date();
				start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
				picker.$emit('pick', [start, end]);
				}
			},{
				text: '最近一周',
				onClick(picker) {
				const end = new Date();
				const start = new Date();
				start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
				picker.$emit('pick', [start, end]);
				}
			}, {
				text: '最近一个月',
				onClick(picker) {
				const end = new Date();
				const start = new Date();
				start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
				picker.$emit('pick', [start, end]);
				}
			}, {
				text: '最近三个月',
				onClick(picker) {
				const end = new Date();
				const start = new Date();
				start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
				picker.$emit('pick', [start, end]);
				}
			}]
		},
		firstFlag:true,
		deviceMap:new Map(),
		devices:[],
		projects:[],
		formHeight:0,
		type:sessionStorage.getItem("type"),
		soundVisible:false,
		mp4Src:'',
		baseUrl: window.configuration.minIoUrl,


		isshow:1,
		videoUrl:'',
		dialogVisible:false,
		timer:'',
		heatmapTimer:'',
		ListVideoShow:true,
		palyblock:true,
		getdplayers:null,
		numVideoIndex:null,
		timeNum:0,
		Cwidth:0,
		Cheight:74,
		canvas:null,ctx:null,isstatic:true,timest:'',
		canvansW:null,canVansH:null,defnums:1,isdunums:1,
		minutes_per_step:[0.015,0.2,0.5,1,5,10,15,20,30, 60, 120, 180, 240, 360, 720, 1440],
		graduation_step:16,hours_per_ruler:24,
		start_timestamp:new Date().getTime() - 12*60*60*1000,
		distance_between_gtitle:80,zoom:24,
		g_isMousedown:false,g_isMousemove:false,g_mousedownCursor:null,returnTime:null,
		event:null,pre:0,poTime:null,Pxt:0,defPrx:null,
		videoLists:[],ismousemove:true,
		isshows:false,
		timecell:[],
		tabless:false,
		active: false,
		upInput:null,
		upMapNum:null,
		startAngle:null,
		endAngle:null,
		
		dpTime:null,isplay:false,
		myonum:0,statics:true,
		Nontline:[],iswfer:false,
		timeday:new Date(new Date().setHours(0, 0, 0, 0)),
		result:4,audit:3,events:'',logd:'',Callback:0,Echo:0,sitevalue:'',
		input:'',showid:null,
		props: { multiple: true },
		defVal:0,
  
		business:[],eventList:[],DnoeventL:[],defeventList:[],
		isfokey:true,
		eventValues:[],cshilist:[],setpo:[],loading:'',setTimeNum:null,TimeList:[],TimeListNum:0,daytimes:'',
		urls:null,WHMusic:30,instatics:true,timeStates:null,timesoi:null,audiourl:'',staticsNum:0,audios:'',
		TimeText:null,titleti:'',iframeUrl:'',istitleti:false,nextLenPlay:false,iconP:false,rotateBar:[],Bars:[],
		barStatic:0,canvasT:null,Tcont:null,DBtext:0,defNum:0,maxDB:0,lock_position_frame:[],TimeStatic:null,TcontW:null,TcontH:null,
		circ:null,circTx:null,
		Fmed:null,andFmed:null,
		Sevent:'', Perc:'',
		mapNun:null,upStatic:null,
		curTime:0,
		NotList:[],
		meddle_pos:null,
		listLeng:null,ZNum:0,upclalist:[],
		staticD:[],CanEvent:null,
		dpWidth:0, 
		dpHeight:0,
		Rdplayer:null,
		allScreens:'time',
		emitpieList:[],
		isScreen:false,
		TisScreen:false,
		disabledP:false,
		disabledN:true,
		CenteTime:null,
		isDTime:false,
		DtimeLeft:0,
		DTime:null,
		tispT:false,
		inbreak:false,
		heatMapIns:null,
		dataFormatter:[{
		  min:1,
		  max:10, //设置渐变颜色效果
		  data:[]
		}],etime:0, dtime:0, fps:0,heatmapNum:0,defKey:0,
	  };
	},
	components:{
	  bars
	},
	mounted () {
		this.setTime();
		const self = this
		self.Cwidth = this.$refs.widthc.offsetWidth

		self.Rdplayer = this.$refs.dplayers
		self.getdplayers = new DPlayer({
			container:self.Rdplayer,
			autoplay: false,
			preload: 'auto',
			hotkey: true,
			video:{
				url:self.videoUrl
			}
		})
  
	  self.dpWidth  = self.Rdplayer.clientWidth
	  self.dpHeight = self.Rdplayer.clientHeight
	//   console.log(self.dpHeight)
	  self.CanEvent = this.$refs.CanEvent
	  self.canvas = this.$refs.canvas;
	  self.ctx = self.canvas.getContext("2d");
	  
	  self.canvansW = this.$refs.widthc.offsetWidth;
	  self.canVansH = self.canvas.height;
	  self.audios = this.$refs.audios
  
	  self.canvasT = this.$refs.canvasTriangle
	  self.Tcont = self.canvasT.getContext("2d");
  
	  self.getdplayers.on('play',()=>{
		self.setTimeData()
		self.audios.play()
		if(self.nextLenPlay == true){
		  
		  self.start_timestamp = self.timecell[self.timecell.length -1].beginTime
		  self.returnTime = self.start_timestamp - (self.hours_per_ruler * 3600 * 1000)/2
		  self.set_time_to_middle(self.returnTime,'1');
		  self.barStatic = 3
		  self.clearDB()
  
		  self.TimeStatic = null
		  self.Perc = self.timecell[self.timecell.length -1].eventProb
		  self.Tcont.clearRect(0,0,self.TcontW,self.TcontH);
		  self.nextLenPlay = false
		}
  
		self.barStatic = 1
		self.getDBtext()
	  })
  
	  //fullscreen
	  self.getdplayers.on('canplay', ()=> { 
		let defN = self.getdplayers.video.currentTime
		if(self.getdplayers.paused){
		  self.barStatic = 4
		  self.curTime = self.getdplayers.video.currentTime
		}else{
		  setTimeout(()=>{
			self.curTime = self.getdplayers.video.currentTime
			self.barStatic = 5
		  },5)
		}
		self.defNum = parseInt((self.getdplayers.video.currentTime * 1000) / 40)
  
		if(self.isplay == false){
		  self.setpo = []
		  if(self.dpTime != null){
			self.clearCanvas();
			
			let VLeng = Math.round(defN)
			let hold =  Math.round(self.dpTime)
			let andVH = VLeng - hold
			let oi = parseInt(andVH).toFixed(2)
			self.start_timestamp += oi * 1000
			self.dpTime = VLeng
			self.audios.currentTime = VLeng
			
			if(self.isdunums == 1){
			  self.init(self.start_timestamp,self.timecell,self.defnums - 1);
			}else{
			  self.init(self.start_timestamp,self.timecell);
			}
		  }else{
			self.dpTime = Math.round(defN)
		  }
		}else{
		  self.dpTime = Math.round(defN)
		}
	  })
  
  
	  self.getdplayers.on('pause', ()=> {
		
		clearInterval(self.timest)
		self.audios.pause()
		self.barStatic = 0
  
		self.getDBtext()
	  })
  
  
	  self.getdplayers.on('ended', ()=>{
		if(self.videoUrl == self.timecell[self.timecell.length -1 ].url){      
		  if(self.getdplayers.video.duration == self.getdplayers.video.currentTime){
			self.nextLenPlay = true  
		  }
		}else if(self.videoUrl == self.timecell[self.timecell.length -1 ].wav_info[0]){
		  if(self.getdplayers.video.duration == self.getdplayers.video.currentTime){
			self.nextLenPlay = true  
		  }
		}else{
		  self.nextLenPlay = false
		}
		self.barStatic = 0
  
		if(self.defnums < self.timecell.length - 1){
		  self.defnums += 1
  
		  if(self.timecell[self.defnums].url == '' || self.timecell[self.defnums].url == undefined){
			self.getdplayers.switchVideo({
			  url:self.timecell[self.defnums].wav_info[0]
			})
			self.videoUrl = self.timecell[self.defnums].wav_info[0]
			
		  }else{
			self.getdplayers.switchVideo({
			  url:self.timecell[self.defnums].url
			})
			self.videoUrl = self.timecell[self.defnums].url
  
		  }
		  self.barStatic = 3
		  self.TimeStatic = null
		  self.clearDB()
		  self.setDataValue(self.defnums)
		  
		  self.mousewheelFunc()
		  self.clearCanvas();
		  self.start_timestamp = self.timecell[self.defnums].beginTime - (self.hours_per_ruler * 3600 * 1000)/2 
		  self.init(self.start_timestamp,self.timecell)
		  self.urls = self.timecell[self.defnums].wav_info[0]
		  self.getdplayers.play()
		  self.isplay = true
		  self.codTime()
		  
		}else{
		  self.isplay = false
		  
		  self.getdplayers.pause()
		  self.audios.pause()
		  clearInterval(self.timest)
		  self.barStatic = 0
		}
	  });
	  
  
	  self.getdplayers.on('timeupdate',()=>{
		self.cshitimePlay()
	  })
  
  
	  window.onresize = () => {
		  self.Cwidth = this.$refs.widthc.offsetWidth
		  self.canvansW = this.$refs.widthc.offsetWidth;
		  self.dpWidth  = self.Rdplayer.clientWidth
		  self.dpHeight = self.Rdplayer.clientHeight
		  
		  self.clearCanvas();
		  setTimeout(()=>{
			if(self.isdunums == 1){
			  self.init(self.start_timestamp,self.timecell,self.defnums - 1);
			}else{
			  self.init(self.start_timestamp,self.timecell);
			}
		  },100)
	  };
	  
	},
	methods: {
		//查询项目信息
		getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
					this.projects = res.data.data;
					this.listLoading = false;
			        if(this.projects.length>0){
						this.filters.projectId=this.projects[0].projectId;
						this.getDevices();
					}
				});
		},
		//获取设备列表
		getDevices() {
			let para = {
				projectId: this.filters.projectId
			};
			getDevicesByProjectId(para).then((res) => {
				this.devices = res.data.data;
				//如果当前已选的设备不属于选中的项目，把设备置空
				this.devices.forEach(item => {
						this.deviceMap.set(item.mnCode,item.name);
					});	
					
					
					if(this.devices.length>0){
						this.filters.mn=this.devices[0].mnCode;
					}
					if(this.firstFlag){
						this.firstFlag=false;
						this.getDataList();
					}
			});
		},
		//获取历史数据信息
		getDataList(){
			var starttime='';
			var endtime='';
			if(this.filters.time!=null&&this.filters.time.length>0){
				starttime=formatDate(this.filters.time[0]);
				endtime=formatDate(this.filters.time[1]);
			}
			let para = {
				page: 1,
				limit:999,
				siteCode: this.filters.mn,
				// siteCode:'FUXISITE0006',
				startTime: starttime,
				endTime: endtime

				// startTime: '2023-10-27 00:00:00',
				// endTime: '2023-10-31 00:00:00'
			};

			if(this.filters.siteCode==""){
				this.$message({
					message: "未选择设备",
					type: 'warning'
				})
				return;
			}
			this.listLoading = true;
			getVoiceprintRecognitionList(para).then((res) => { 
				this.listLoading = false;
				const self = this
		
				self.ListVideoShow = true
		
				if(new Date(self.timeday).getTime() >= new Date(new Date(new Date().toLocaleDateString())).getTime()){
					self.disabledN = true
				}else{
					self.disabledN = false
				}

				if(res.data == '' || res.data == undefined){
					self.CloseEvent()
					return false
				}
				self.tispT = true
				self.disabledP = false
				self.iconP = true
				self.TimeList = []
				self.setpo = []
				self.Nontline = []
				self.TimeListNum = 0
				self.TimeList[self.TimeListNum] = []
				
				self.isshows = false
				self.timecell = []
		
				var resData=res.data.data;

				self.emitpieList = []
				var noiseMap=new Map();
				
				for(let f = 0; f < resData.length;f++){
					//对于代码和接口参数名称不一致进行修改
					resData[f].beginTime=resData[f].cutTime+'000';
					resData[f].endTime=resData[f].postTime+'000';
					resData[f].url=self.baseUrl+resData[f].sourceName;
					resData[f].wav_info=[self.baseUrl+resData[f].singleChannelName];
					try{
						resData[f].freqs_frame=JSON.parse(resData[f].freqsFrames);
					}catch(e){
						resData[f].freqs_frame=resData[f].freqsFrames;
					}
					try{
						resData[f].lock_position_frame=JSON.parse(resData[f].lockPositionFrames);
					}catch(e){
						resData[f].lock_position_frame=resData[f].lockPositionFrames;
					}
					try{
						resData[f].db_frame=JSON.parse(resData[f].dbFrame) ;
					}catch(e){
						resData[f].db_frame=resData[f].dbFrame;
					}
					try{
						resData[f].eventLabelCn=JSON.parse(resData[f].eventLabelCn) ;
					}catch(e){
						resData[f].eventLabelCn=resData[f].eventLabelCn;
					}
					try{
						resData[f].eventProb=JSON.parse(resData[f].eventProb);
					}catch(e){
						resData[f].eventProb=resData[f].eventProb;
					}

					var eventLabelCn=resData[f].eventLabelCn;
					var val=noiseMap.get(eventLabelCn);
					if(val==undefined){
						noiseMap.set(eventLabelCn,1);
					}else{
						noiseMap.set(eventLabelCn,val+1);
					}
				}

				noiseMap.forEach(function(value, key) {
					self.emitpieList.push({value:value,name:key})
				});

				self.timecell = resData
				for(let k = 0;k <self.timecell.length;k++){
					self.timecell[k]['timeSlot'] = new Date(self.timecell[k].beginTime).getHours()
				}
		
				self.timeNum = 0
				self.start_timestamp = new Date(self.timeday).getTime() + 12 * 3600 * 1000
		
				self.init(self.start_timestamp,self.timecell,self.defnums - 1);
				self.returnTime = self.start_timestamp
				self.fooList()
		
		
				let towTime =  2.6 * 3600 * 1000
				let NonList = []
  
				//列表分组
				for(let f = 0; f < resData.length;f++){
					if(resData.length == 1){
						self.Nontline.push(resData[f].beginTime)                                                         //修改style样式 left距离
						self.TimeList[self.TimeListNum].push({url:res.data[f].url,wav_info:resData[f].wav_info[0]})      //获取第一个数组的 第一个下标放入数据
						return false
					}
					if(f + 1 < resData.length){
						if(resData[f + 1].endTime - resData[f].endTime >= towTime){                                     //判断第n + 1 - 第n个 是否大于等于固定值的时间
							self.TimeList[self.TimeListNum].push({url:resData[f].url,wav_info:resData[f].wav_info[0]})    
							self.TimeListNum += 1                                                                           //存放数据的数组 下标数加一
							self.TimeList[self.TimeListNum] = []                                                            //为数组类型
							self.Nontline.push(resData[Math.min(...NonList)].beginTime)                                    //获取下标为最小的值作为起始点绘制
							NonList = []                                                                                    //清空
						}else{
							NonList.push(f)
							
							if(resData[f + 1].beginTime - resData[Math.min(...NonList)].beginTime >= towTime){         
								self.Nontline.push(resData[Math.min(...NonList)].beginTime)
								self.TimeListNum += 1
								self.TimeList[self.TimeListNum] = []
								NonList = []
							}
							self.TimeList[self.TimeListNum].push({url:resData[f].url,wav_info:resData[f].wav_info[0]})      //循环放入数据
						}
					}else{
						if(Math.min(...NonList) == Infinity || Math.min(...NonList) == -Infinity){
							self.Nontline.push(resData[f].beginTime)
						}else{      
							
							self.Nontline.push(self.timecell[Math.min(...NonList)].beginTime)
						}
			
						self.TimeList[self.TimeListNum].push({url:self.timecell[f].url,wav_info:self.timecell[f].wav_info[0]})            
					}
				}
		
				self.isfokey = !self.isfokey
		
				this.$forceUpdate()

				
			}).catch(() => {
				this.listLoading = false;
			});
		},  
		showIdent(i,row){
			this.mp4Src=row.sourceName;
			this.soundVisible=true;
		},
		setTime(){
			var end = new Date();
			var start = new Date();
			start.setTime(start.setDate(start.getDate()-2));
			//设置不同的时间区间
			this.filters.time= [formatDate(start), formatDate(end)];
			this.getProjects();

		},
	  DTimestyle(){
		const self = this
		return `left:${self.DtimeLeft}px`
	  },
	  VideoList(width){
		return `width:${width}px`
	  },
	  XScreen(){
		const self = this
		self.isScreen = !self.isScreen
	  },
	  enterE(){
		const self = this
		let canvas = self.canvas;
		canvas.removeEventListener('mousewheel',self.mousewheelFunc,{ passive:false });
		canvas.removeEventListener('click',self.dblclickFunc);
		canvas.removeEventListener('mousedown',self.mousedownFunc);
		canvas.removeEventListener('mouseout',self.mouseoutFunc);
		window.document.removeEventListener('mouseup',self.mouseupFunc,false);
		this.$refs.canvasf.removeEventListener('mousemove',self.mousemoveFunc,false);
	  },
	  leaveE(){
		const self = this
		self.add_events()
	  },
	  jumpTime(type,e){
		const self = this
		let datatime;
		if(type == 'next'){
		  datatime = new Date(self.timeday).getTime() + 24*3600*1000
		}else{
		  datatime = new Date(self.timeday).getTime() - 24*3600*1000
		}
		self.timeday = new Date(datatime)
		self.getDataList()
	  },
	  setHeight(){
		const self = this
		return `height:${self.Cheight + 1}px`
	  },
	  upMap(){
		const self = this
  
		if(self.upMapNum != null){
		  let radio = Number(self.upMapNum)
		  self.useCirc(self.startAngle,self.endAngle,radio)
		}
		
	  },
  
	  handler ({BMap, map}) {
		let me = this;
		// 鼠标缩放
		// map.enableScrollWheelZoom(true);
		// 点击事件获取经纬度
		map.addEventListener('click', function (e) {
			// console.log(e.point.lng, e.point.lat)
		})
	  },
	  CanEvents(e){
		const self = this
		self.cutBtn()
  
	  },
	  BubblePlay(){
		const self = this
		self.cutBtn()
  
	  },
	  cutBtn(){
		const self = this
  
		if(self.getdplayers.paused){
		  self.getdplayers.play()
		}else{
		   self.getdplayers.pause()
		}
	  },
  
	  cshitimePlay(){
		const self = this
		for(let key in self.lock_position_frame){
		  if(self.TimeStatic == null){
			if(key * 40 <= self.getdplayers.video.currentTime * 1000){
			  let random = Math.round(Math.random()*190+95);
			  //逆时针
			  if(self.upStatic != null || self.meddle_pos != null){
				if(self.meddle_pos != null){
				  self.Fmed = self.lock_position_frame[key].ellipse_medium_x + Number(self.meddle_pos)
				}else{
				  self.Fmed = self.lock_position_frame[key].ellipse_medium_x + self.upStatic
				}
				
				self.mapNun = self.lock_position_frame[key].ellipse_medium_ang_map - (self.upStatic / 0.5) * 45   // 地图上的角度 
  
			  }else{
  
				self.Fmed = self.lock_position_frame[key].ellipse_medium_x
				self.mapNun = self.lock_position_frame[key].ellipse_medium_ang_map
  
			  }
			  
			  self.TimeStatic = Number(key)
			  self.startAngle = self.mapNun * (Math.PI / 180) - 0.2
			  self.endAngle = self.mapNun * (Math.PI / 180) + 0.2
  
			  let L = (self.Fmed * self.canvasT.width) - random
			  let R = (self.Fmed * self.canvasT.width) + random
  
			  self.useTcan(L,R)
			  if(self.upMapNum != null){
				self.useCirc(self.startAngle,self.endAngle,Number(self.upMapNum)) 
			  }else{
				self.useCirc(self.startAngle,self.endAngle) 
			  }
			}
		  }else{
			//正时针
			if(Number(key) > self.TimeStatic && self.TimeStatic * 40 <= self.getdplayers.video.currentTime * 1000){
			  let random = Math.round(Math.random()*190+95);
				if(self.upStatic != null || self.meddle_pos != null){
				  if(self.meddle_pos != null){
				  self.Fmed = self.lock_position_frame[key].ellipse_medium_x + Number(self.meddle_pos)
				}else{
				  self.Fmed = self.lock_position_frame[key].ellipse_medium_x + self.upStatic
				}
				self.mapNun = self.lock_position_frame[key].ellipse_medium_ang_map  - (self.upStatic / 0.5) * 45
			  }else{
				self.Fmed = self.lock_position_frame[key].ellipse_medium_x
				self.mapNun = self.lock_position_frame[key].ellipse_medium_ang_map
			  }
			  
			  self.startAngle = self.mapNun * (Math.PI / 180) - 0.2
			  self.endAngle = self.mapNun * (Math.PI / 180) + 0.2
  
			  let L = (self.Fmed * self.canvasT.width) - random
			  let R = (self.Fmed * self.canvasT.width) + random
  
			  self.useTcan(L,R)
			  if(self.upMapNum != null){
				self.useCirc(self.startAngle,self.endAngle,Number(self.upMapNum)) 
			  }else{
				self.useCirc(self.startAngle,self.endAngle) 
			  }
			  
			  self.TimeStatic = Number(key)
			  break;
			}
		  }
		}
  
	  },
  
	  ZlistName(list,UpList){
		const self = this
  
		for(let i=0;i<list.length;i++){
		  if(UpList[self.ZNum] == self.eventList[i].label_value){
			self.upclalist.push(self.eventList[i].label_name)
		  }
		}
  
		self.ZNum += 1
		if(self.ZNum <= list.length){
		  self.ZlistName(list,UpList)
		}
		
	  },
  
	  useTcan(Langle,Rangle){

		const self = this
  
		self.TcontW =  self.canvasT.width
		self.TcontH = self.canvasT.height
  
		self.Tcont.clearRect(0,0,self.TcontW,self.TcontH);
	   
		self.Tcont.beginPath()
		self.Tcont.moveTo(self.TcontW/2,self.TcontH)
  
		//变位置
		self.Tcont.lineTo(Langle,0)      
		self.Tcont.lineTo(Rangle,0)
  
		// self.Tcont.fillStyle = 'RGBA(250, 250, 250,0.5)'
		self.Tcont.fillStyle = 'RGBA(239, 248, 245,0.5)'
  
		// color: rgba(184, 255, 231, 0.6);
		self.Tcont.fill()
  
  
	  },
  
	  useCirc(startA,endA,radio){
		const self = this
		if(radio == undefined){
		  radio = 60
		}else{
		  radio += 60
		}
  
	  },
  
	  CloseEvent(){
		const self = this
		self.disabledP = true
		self.disabledN = true
		self.tispT = false
		self.TimeList = []
		self.setpo = []
		self.Nontline = []
		self.timecell = []  
		self.isshows = true
		self.iconP = false
		self.clearCanvas();
  
	  },
	  //筛选类型、日期、列表视频
	  screen(){
		const self = this
		self.dialogVisible = true
		self.isshow = 1
		self.timer = new Date().getTime()
	  },
  
	  //点击样式
	  setVC(index,i,url){
		const self = this
		if(url == self.videoUrl){
		  return 'video_play_bor video_play'
		}else{
		  return 'video_play '
		}
	  },
	  setVT(index,i,url){
		const self = this
		if(url == self.videoUrl){
		  return 'video_play_bor video_play_Text'
		}else{
		  return 'video_play_Text '
		}
	  },
  
	  //关闭弹窗
	  handleClose(done){
		done();
	  },
  
	  //列表时间转换为 小时 ： 分钟 ： 秒数
	  formateTime(time) {
		
		const h = parseInt(((time / 3600) * 100) /100).toFixed(0)
		const minute = parseInt(((time / 60 % 60) * 100) /100).toFixed(0)
		const second = Math.ceil(time % 60)    
   
		const hours = h < 10 ? '0' + h : h
		const formatSecond = second > 59 ? 59 : second
  
		return `${hours > 0 ? `${hours}:` : ''}${minute < 10 ? '0' + minute : minute}:${formatSecond < 10 ? '0' + formatSecond : formatSecond}`
	  },
  
	  proload(i){
		const self = this
  
		return new Promise((resolve,reject)=>{
		  setTimeout(()=>{
			console.log('执行',this.$refs.videourls[i]);
			this.$refs.videourls[i].load();
			this.$refs.videourls[i].onloadedmetadata = (()=>{
			  if(this.$refs.videourls[i].duration == undefined){
				return false
			  }
			  let Dura = this.$refs.videourls[i].duration
			  self.videoLists[i].duration = self.formateTime(Dura)
			})
			resolve(1)
		  },10)
		})
	  },
	  //更换视频
	  async reVio(num,Url,index,audio){
		const self = this
  
		if(num == '1'){
		  self.videoLists = []
		  self.inbreak = false
		  
		  Url.map(m=>{
			self.videoLists.push({"url":m.url,"duration":'',"minute":'',"wav_info":m.wav_info})
		  })
  
		  self.ListVideoShow = false
  
		   for(let i=0;i<self.videoLists.length;i++){
			  if(self.inbreak == true){
				break;
			  }
			  await self.proload(i)
		  }
		}
		
		if(num == '2'){
		  self.ListVideoShow = true
		  self.inbreak = true
		}
  
		if(num == '3'){
		  self.isdunums = 2
		  self.palyblock = false
		  self.numVideoIndex = index
		  
		  self.clearCanvas();
		  self.defnums = index
		  self.isplay = true
  
		  if(Url.url == '' || Url.url == undefined){
			self.getdplayers.switchVideo({
			  url:Url.wav_info[0]
			})
			self.videoUrl = Url.wav_info[0]
		  }else{
			self.getdplayers.switchVideo({
			  url:Url.url
			})
			self.videoUrl = Url.url
		  }
		  
		  self.urls = audio
		  self.audios.play()
		  self.codTime()
		  self.barStatic = 3
		  self.clearDB()
  
  
		  for(let i=0;i<self.timecell.length;i++){
			if(Url == self.timecell[i].url){
			 self.start_timestamp = self.timecell[i].beginTime - (self.hours_per_ruler * 3600 * 1000)/2
			 self.defnums = i
			 self.setDataValue(i)
			}
		  }
		  self.TimeStatic = null
		  self.Tcont.clearRect(0,0,self.TcontW,self.TcontH);
		  self.pre = self.start_timestamp
		  self.init(self.start_timestamp,self.timecell)
		  self.getdplayers.play()
		  self.setTimeData()
		}
  
	  },
  
	  //鼠标离开时间轴时
	  codTime(){
		const self = this
		setTimeout(()=>{self.isplay = false},200)
	  },
  
	  //绘制时间轴的主函数
	  init(start_timestamp,timecell,setText){
		const self = this
		let canvansW = self.canvansW, 
		canVansH = self.canVansH;                   //宽度
		if(timecell.length > 0){
		  self.drawCellBg();                          //刻度背景
		  self.add_graduations(start_timestamp);      //绘制刻度
		  self.add_cells(timecell);                   //录像
		  self.drawLine(0,canVansH,canvansW,canVansH,"rgb(151, 158, 167)",1); //底线
		  self.drawLine(canvansW/2,0,canvansW/2,30,"rgb(255, 0, 0)",2);     //中间播放点时间线
		  self.add_events();                          //事件
		  var time = start_timestamp + (self.hours_per_ruler*3600*1000)/2;    //中间值
		  self.ctx.fillStyle = "rgba(81, 81, 81,1)"                         //设置字体颜色
		  self.CenteTime = self.changeTime(time)
		}
	  },
  
	  add_graduations(start_timestamp){
		const self = this
		let canvansW = self.canvansW,
		hours_per_ruler = self.hours_per_ruler,
		graduation_step = self.graduation_step,
		minutes_per_step = self.minutes_per_step,
		distance_between_gtitle = self.distance_between_gtitle;
  
  
		var px_per_min = canvansW / (hours_per_ruler * 60); // px/min
		var px_per_ms = canvansW / (hours_per_ruler * 3600 * 1000); // px/ms
		var px_per_step = graduation_step;  // px/格 默认最小值20px
		var min_per_step = px_per_step / px_per_min; // min/格
		for(var i = 0; i < minutes_per_step.length;i++){ 
			if(min_per_step <= minutes_per_step[i]){ //让每格时间在minutes_per_step规定的范围内
				min_per_step = minutes_per_step[i]; 
				px_per_step = px_per_min * min_per_step;
				break
			}
		}
  
		var medium_step = 30;
		for (var i = 0; i < minutes_per_step.length; i++) {
			if (distance_between_gtitle / px_per_min <= minutes_per_step[i]) {
				medium_step = minutes_per_step[i];
				break;
			}
		}
  
		var num_steps = canvansW / px_per_step; //总格数
		var graduation_left;
		var graduation_time;
		let ctx = self.ctx;
		var lineH,topH;
  
		var ms_offset = self.ms_to_next_step(start_timestamp,min_per_step*60*1000);//开始的偏移时间 ms
		var px_offset = ms_offset * px_per_ms; //开始的偏移距离 px
  
  
		var ms_per_step = px_per_step / px_per_ms; // ms/step
		var fontColor = 'rgba(81, 81, 109,1)'
		for(var i = 0; i < num_steps; i++){
			graduation_left = px_offset + i * px_per_step; // 距离=开始的偏移距离+格数*px/格
			graduation_time = start_timestamp + ms_offset + i * ms_per_step; //时间=左侧开始时间+偏移时间+格数*ms/格
			let caret_class;
			var date = new Date(graduation_time);
			
		  if (date.getHours() == 0 && date.getMinutes() == 0) {//判断零点
			  caret_class = "big";
			  lineH = 30;
			  topH = 20;
			  var big_date = "00:00";
			  ctx.fillStyle = fontColor; //  0点 特殊 字体样式
			  ctx.fillText(big_date, graduation_left - 10,15);
			} else if ((graduation_time / (60 * 1000)) % medium_step == 0) {
			  
			  caret_class = "middle";
			  lineH = 30;
			  topH = 20;
			  var middle_date = self.graduation_title(date);
			  
			  ctx.fillStyle = fontColor; 
			  ctx.fillText(middle_date, graduation_left - 10, 15);
			} 
			else{
			  lineH = 30;
			  topH = 25;
			}
			self.drawLine(graduation_left,topH,graduation_left,lineH,"rgba(110, 110, 110,1)",1);
		}
	  },
  
	  drawLine(beginX,beginY,endX,endY,color,width){
		const self = this
		let ctx = self.ctx
		
		ctx.beginPath();
		ctx.moveTo(beginX,beginY);
		ctx.lineTo(endX,endY);
		ctx.strokeStyle = color;
		ctx.lineWidth = width;
		ctx.stroke();
  
	  },
  
	  add_cells(cells){
		const self = this
	   
		cells.map(m=>{
		  self.draw_cell(m,'1')
		  if(m.filterList != undefined){
			m.filterList.filter((o,i,arr)=>{
			  if(arr.length > 1){
				let bb = arr[0].beginTime
				if(i != 0 && arr[i].beginTime == arr[i - 1].beginTime){
				  arr[i]["RHeight"] = arr[i - 1]["RHeight"] + 5
				}else{
				  if(bb == arr[i].beginTime){
					o["RHeight"] = (i + 1) * 5
				  }else{
					o["RHeight"] = 5
				  }
				}
			  }else{
				o["RHeight"] = (i + 1) * 40
			  }
			  self.draw_cell(o,'2')
			})
		  }
		  return m.filterList
		})
  
	  },
  
	  draw_cell(cell,num){
		const self = this
		let canvansW = self.canvansW,
		hours_per_ruler = self.hours_per_ruler,
		ctx = self.ctx,
		start_timestamp = self.start_timestamp;
  
		var px_per_ms = canvansW / (hours_per_ruler * 3600 * 1000); // px/ms
		var beginX = (cell.beginTime - start_timestamp) * px_per_ms;    //开始到有数据的边距边距
		
		var cell_width = (cell.endTime - cell.beginTime ) * px_per_ms;
  
	  
		if(self.zoom >= 0 && self.zoom <= 10){
		  if(Math.sign(beginX) > 0 && beginX <= canvansW){
			if(self.cshilist.indexOf(cell.beginTime) == -1){
			  self.cshilist.push(cell.beginTime)
			  
			  
			  for(let i=0;i<self.timecell.length;i++){
				if(self.cshilist[0] == self.timecell[i].beginTime){
				  self.TimeText = i
				}
				if(self.cshilist[self.cshilist.length - 1] == self.timecell[i].beginTime){
					self.listLeng = i + 1
				}
			  }
			  
			}
		  }
		}
		
		if(num == '1'){
		  ctx.fillStyle = "rgba(132, 244, 180, 0.498039)";          //录像片段的时间戳背景
		  ctx.fillRect(beginX,30,Math.ceil(cell_width),10);
  
		  
  
		  for(let i=0;i<self.Nontline.length;i++){
  
  
			let andTimes = (self.Nontline[i] - start_timestamp) * px_per_ms
  
			if(Math.sign(andTimes) != -1){
			  if(andTimes >= 0 && andTimes <= self.canvansW){
				ctx.fillStyle = "rgba(198, 198, 198, 0.498039)";
				ctx.fillRect(andTimes,30,0.5,100);
			  }
  
			//   if(self.setpo.indexOf(andTimes) == -1){
			// 	  self.setpo.push(andTimes)
			// 	  setTimeout(()=>{
			// 		  if(this.$refs.defDL != undefined){
			// 		  for(let f = 0;f<this.$refs.defDL.length;f++){
			// 			if(this.$refs.defDL[f].style.left == ''){
			// 			  this.$refs.defDL[f].style.display = 'none'
			// 			}else{
			// 			  this.$refs.defDL[f].style.display = 'inline-block'
			// 			}
			// 		  }
			// 		}
			// 	},500)
			//   }
			  
			}
		  }
		  
		}else if(num == '2'){
		  ctx.fillStyle = cell.background;          //录像片段的时间戳背景
		  ctx.fillRect(beginX,cell.RHeight,Math.ceil(cell_width),10);
		}
	  },
  
	  drawCellBg(){
		const self = this
		let ctx = self.ctx,
		canvansW = self.canvansW;
		ctx.fillStyle = "rgba(200, 200, 200, 1)";
  
		ctx.fillRect(0,30,canvansW,1);
	  },
	  
	  add_events(){
		const self = this
		let canvas = self.canvas;  
		canvas.addEventListener('mousewheel',self.mousewheelFunc,{ passive:false });       //滚动
		canvas.addEventListener('click',self.dblclickFunc);             //点击
		canvas.addEventListener('mousedown',self.mousedownFunc);        //鼠标移入
		canvas.addEventListener('mouseout',self.mouseoutFunc);          //鼠标移出
		window.document.addEventListener('mouseup',self.mouseupFunc,false);
		this.$refs.canvasf.addEventListener('mousemove',self.mousemoveFunc,false);
	  },
  
	  dblclickFunc(e){
		const self = this
		self.setpo = []
		self.nextDat()
		if(self.statics == true){
		   let andTime = (self.hours_per_ruler / 2)*3600*1000
			self.start_timestamp = self.poTime - (self.hours_per_ruler*3600*1000)/2
			for(let i=0;i<self.timecell.length;i++){            
			  if(self.start_timestamp >= self.timecell[i].beginTime - andTime && self.start_timestamp < self.timecell[i].endTime - andTime){
				
				let defT = (self.timecell[i].beginTime - (self.hours_per_ruler*3600*1000)/2)
				let getT = (defT - self.start_timestamp) / 1000
				if(i != self.defnums){
				  self.getdplayers.switchVideo({
					url:self.timecell[i].url
				  })
				  self.barStatic = 3
				  self.clearDB()
				  self.TimeStatic = null
				  self.Tcont.clearRect(0,0,self.TcontW,self.TcontH);
				  if(self.timecell[i].url == '' || self.timecell[i].url == undefined){
					self.videoUrl = self.timecell[i].wav_info[0]
				  }else{
					self.videoUrl = self.timecell[i].url
				  }
				  
				  self.setDataValue(i)
				  self.urls = self.timecell[i].wav_info[0]
  
				  self.defnums = i
				  self.Pxt = 0
				  self.pre = self.start_timestamp
				}
				self.getdplayers.seek((Math.abs(getT)).toFixed(2))
				self.audios.currentTime = (Math.abs(getT)).toFixed(2)
  
  
				self.getdplayers.play()
				self.audios.play()
  
				return false
			  }
		  }
		  self.returnTime = self.start_timestamp;
  
		  self.fooList()
		  
		  setTimeout(()=>{
			self.getdplayers.play()
			self.audios.play()
		  },300)
		}
	  },
  
	  mousedownFunc(e){
		const self = this;
		self.g_isMousedown = true;
		self.g_mousedownCursor = self.get_cursor_x_position(e);     //记住mousedown的位置
		self.pre = self.start_timestamp
	  },
  
	  mousemoveFunc(e){
		const self = this
		self.event = e
		var pos_x = self.get_cursor_x_position(e)
		var px_per_ms = self.canvansW / (self.hours_per_ruler * 60 * 60 * 1000); // px/ms
		self.ismousemove = true
		if(self.g_isMousedown){
			//鼠标拖动时
			self.clearCanvas();
			
			self.nextDat()
			self.isstatic = false
			self.isplay = true
			self.ismousemove = false
			self.statics = false
			self.setpo = []
			
			var diff_x = pos_x - self.g_mousedownCursor;
			self.start_timestamp = self.start_timestamp - Math.round(diff_x / px_per_ms);
			self.init(self.start_timestamp,self.timecell);
			self.g_isMousemove = true;
			self.g_mousedownCursor = pos_x;
			self.getdplayers.pause()
			self.audios.pause()
			self.barStatic = 0
  
  
			clearInterval(self.timest)
  
			let andTime = (self.hours_per_ruler / 2)*3600*1000
			
			for(let i=0;i<self.timecell.length;i++){            
			  if(self.start_timestamp >= self.timecell[i].beginTime - andTime && self.start_timestamp < self.timecell[i].endTime - andTime){
				if(i != self.defnums){
				  self.isdunums = 2
				  self.getdplayers.switchVideo({
					url:self.timecell[i].url
				  })
				  self.barStatic = 3
				  self.clearDB()
				  self.TimeStatic = null
				  self.Tcont.clearRect(0,0,self.TcontW,self.TcontH);
  
				  self.setDataValue(i)
				  
				  if(self.timecell[i].url == '' || self.timecell[i].url == undefined){
					self.videoUrl = self.timecell[i].wav_info[0]
				  }else{
					self.videoUrl = self.timecell[i].url
				  }
				  
				  self.urls = self.timecell[i].wav_info[0]
				  
				  
				  self.defnums = i
				  self.Pxt = 0
				  self.pre = self.start_timestamp
				  self.defPrx = null
				}
				if(Math.sign(self.Pxt.toFixed(2)) == -1 || Math.sign(self.Pxt.toFixed(2)) === 0){
				  let setT = (self.timecell[i].beginTime - (self.hours_per_ruler*3600*1000)/2)
				  let datT = (setT - self.start_timestamp) / 1000
				  self.getdplayers.seek((Math.abs(datT)).toFixed(2))
				  self.audios.currentTime = (Math.abs(datT)).toFixed(2)
				  return false
				}
  
				self.Pxt = (self.start_timestamp - self.pre) / 1000
				if(self.defPrx != null){    //判断是否存在数据中
				  self.Pxt += self.defPrx
				}
				// console.log('self.Pxt===',self.Pxt);
				self.getdplayers.seek(self.Pxt.toFixed(2))
  
				
				self.audios.currentTime = self.Pxt.toFixed(2)
  
			  }
			}
		}else{
			//移入
			if(self.ismousemove){
			  self.clearCanvas();
			  var time = self.start_timestamp + pos_x/px_per_ms;
			  self.poTime = time;
			  self.isplay = true
			  
			  if(self.isdunums == 1){
				if(self.defnums <= 0){
				  self.defnums = 1
				}
				self.init(self.start_timestamp,self.timecell,self.defnums - 1);
			  }else{
				self.init(self.start_timestamp,self.timecell);
			  }
			  self.isDTime = true
			  self.DTime = self.changeTime(time)
			  self.DtimeLeft = pos_x - 90
			  self.drawLine(pos_x,0,pos_x,30,"rgb(81, 81, 81)",0.5);
  
			}
		}
  
	  },
  
	  setTimeData(){
		const self = this
		
		if(self.timest != ""){
		  clearInterval(self.timest)
		  self.timest = ""
		}
  
		if(self.timest == ""){
		  self.timest = setInterval(()=>{
			
			self.autoRoll()
  
			self.clearCanvas();
			self.start_timestamp = self.start_timestamp + 1000
			
			self.init(self.start_timestamp,self.timecell)
			
			
		  },1000)
		}
  
	  },
	  
	  mouseupFunc(e){  //鼠标拖动放开时
		const self = this
		if(self.g_isMousemove){ //拖动 事件
			self.g_isMousemove = false;
			self.g_isMousedown = false;
			self.ismousemove = false
			
			window.document.removeEventListener('mousemove',self.mousemoveFunc,false);
			// self.isplay = true
			self.returnTime = self.start_timestamp;
			self.setTimeData()
			
			self.codTime()
			self.fooList()
			self.barStatic = 3
			
			setTimeout(()=>{
			  self.getdplayers.play()
			  self.audios.play()
			  self.statics = true
			  self.setpo = []
			  self.mousewheelFunc()
  
			},300)
		  }else{ // click 事件
			  self.g_isMousedown = false;
		  }
	  },
  
	  mouseoutFunc(e){
		const self = this
		self.clearCanvas();
		self.codTime();
		self.ismousemove = false
		self.isDTime = false
		this.$refs.canvasf.removeEventListener('mousemove',self.mousemoveFunc,false);
		if(self.g_isMousemove == true){
		  window.document.addEventListener('mousemove',self.mousemoveFunc,false);
		}else{
		  self.codTime();
		}
  
		
		if(self.isdunums == 1){
		  self.init(self.start_timestamp,self.timecell,self.defnums - 1);
		}else{
		  self.init(self.start_timestamp,self.timecell);
		}
	  },
  
	  nextDat(){
		const self = this
		if(self.videoUrl == self.timecell[self.timecell.length -1 ].url || self.videoUrl == self.timecell[self.timecell.length -1 ].wav_info[0]){      
		  self.nextLenPlay = true
		}else{
		  self.nextLenPlay = false
		}
	  },
  
	  mousewheelFunc(){
		const self = this
		  if(self.event != null){
			if(self.event && self.event.preventDefault){
			  self.event.preventDefault()
			}else{
				self.event.returnValue = false;
				return false;
			}
		  }
		
		self.nextDat()
		var e = window.event || self.event;
		var delta = Math.max(-1,Math.min(1,(e.wheelDelta || -e.detail)));
		var middle_time = self.start_timestamp + (self.hours_per_ruler*3600*1000)/2; //ms 记住当前中间的时间
  
		if (delta < 0) {
		  if(self.zoom >= 1 && self.zoom < 4){
			  self.zoom += 3
		  }else if(self.zoom >= 0.4 && self.zoom < 1){
			  self.zoom += 0.5
		  }else if(self.zoom >= 0.09 && self.zoom < 0.4){
			  self.zoom += 0.41
		  }else if(self.zoom >= 0.015 && self.zoom < 0.09){
			  self.zoom += 0.075
		  }else{
			  self.zoom += 5;
		  }
			
		  if (self.zoom >= 24) {
			self.zoom = 24;//放大最大24小时
		  }
		  self.hours_per_ruler = self.zoom;
	  
		} else if (delta > 0) {// 放大
		  if(self.zoom <= 4.3 && self.zoom > 2){
			  self.zoom -= 3
		  }else if(self.zoom <= 2 && self.zoom > 0.5){
			  self.zoom -= 0.5
		  }else if(self.zoom <= 0.5 && self.zoom >= 0.1){
			  self.zoom -= 0.4
		  }else{
			  self.zoom -= 5;
		  }
			  if (self.zoom < 0.09) {
				  self.zoom = 0.015;//缩小最小1小时
		  }
		  self.hours_per_ruler = self.zoom;
		}
		if(self.zoom == 0.09999999999999998){
		  self.zoom = 0.09
		  self.hours_per_ruler = self.zoom
		}
  
		self.setTimelintf()
		
		self.start_timestamp = middle_time - (self.hours_per_ruler*3600*1000)/2; //start_timestamp = 当前中间的时间 - zoom/2
  
		if(self.isdunums == 1){
		  self.init(self.start_timestamp,self.timecell,self.defnums - 1);
		}else{
		  self.init(self.start_timestamp,self.timecell);
		}
  
	  },
  
	  setTimelintf(){
		const self = this
		
		self.TimeListNum = 0
		self.Nontline = []
		self.TimeList = []
		self.TimeList[self.TimeListNum] = []
		self.instatics = true
		self.cshilist = []
		self.staticsNum = 0
  
		self.staticD = []
  
		 if(self.zoom == 24){
			  //24
			  self.getlistfil(2.6*3600*1000,0,2.6*3600*1000,self.timecell.length);    
		  }
		  else if(self.zoom > 15 && self.zoom < 24){
			  //16 -19
			  self.getlistfil(2.1*3600*1000,0,2.1*3600*1000,self.timecell.length);
			  
		  }else if(self.zoom > 10 && self.zoom <= 15){
			  //11 - 15
			  self.getlistfil(1.5*3600*1000,0,1.5*3600*1000,self.timecell.length);
			  
		  }else if(self.zoom > 5 && self.zoom <= 10){
			  //6 - 9
			  setTimeout(()=>{
				self.getlistfil(0.98*3600*1000,self.TimeText,0.98*3600*1000,self.listLeng);
			  },10)
		  }else if(self.zoom > 2 && self.zoom <= 5){
			  //2.1 - 4
			  setTimeout(()=>{
				self.getlistfil(0.42*3600*1000,self.TimeText,0.42*3600*1000,self.listLeng);
			  },10)
		  }else if(self.zoom > 0.6 && self.zoom <= 2){
			  //0.7 - 2
			   setTimeout(()=>{
				self.getlistfil(0.102*3600*1000,self.TimeText,0.102*3600*1000,self.listLeng);
			  },10)
		  }else if(self.zoom > 0.1 && self.zoom <= 0.6){
			  //0.11 - 0.6
			  setTimeout(()=>{
				self.getlistfil(0.058*3600*1000,self.TimeText,0.0535*3600*1000,self.listLeng);
			  },10)
		  }
		  else if(self.zoom >= 0.05 && self.zoom <= 0.1){
			  //0.05 - 0.1
			   setTimeout(()=>{
				self.getlistfil(0.01*3600*1000,self.TimeText,0.01*3600*1000,self.listLeng);
			  },10)
		  }
		  else{
			setTimeout(()=>{
			  self.getlistfil(0.001*3600*1000,self.TimeText,0.001*3600*1000,self.listLeng);
			},10)
		  }
  
		self.clearCanvas();
		self.setpo = []
	  },
	  
	  getlistfil(towTime,num,upTime,leng){
		const self = this
		let daytime = null,statics = null,leverStatics = false;
		self.NotList = []
  
		for(let f = num; f < leng;f++){
		  if(leng == 1){
			self.Nontline.push(self.timecell[f].beginTime)
			self.TimeList[self.TimeListNum].push({url:self.timecell[f].url,wav_info:self.timecell[f].wav_info[0]})
			return false
		  }
		  if(f + 1 < leng){
			self.NotList.push(f)
			if(self.timecell[f + 1].endTime - self.timecell[f].endTime >= towTime){
			  self.TimeList[self.TimeListNum].push({url:self.timecell[f].url,wav_info:self.timecell[f].wav_info[0]})
			  self.TimeListNum += 1
			  self.TimeList[self.TimeListNum] = []
			  self.Nontline.push(self.timecell[Math.min(...self.NotList)].beginTime)
			  self.NotList = []
			}else{  
			  self.TimeList[self.TimeListNum].push({url:self.timecell[f].url,wav_info:self.timecell[f].wav_info[0]})  
			  if(self.timecell[f + 1].beginTime - self.timecell[Math.min(...self.NotList)].beginTime >= upTime){
				self.Nontline.push(self.timecell[Math.min(...self.NotList)].beginTime)
				self.TimeListNum += 1
				self.TimeList[self.TimeListNum] = []
				self.NotList = []
			  }
			  
			}
		  }else{
			  if(Math.min(...self.NotList) == Infinity || Math.min(...self.NotList) == -Infinity){
				self.Nontline.push(self.timecell[f].beginTime)
			  }else{      
				self.Nontline.push(self.timecell[Math.min(...self.NotList)].beginTime)
			  }
			  self.TimeList[self.TimeListNum].push({url:self.timecell[f].url,wav_info:self.timecell[f].wav_info[0]})  
		  }
		  this.$forceUpdate()
		}
  
	  },
  
	  autoRoll(){
		const self = this
		let deflRollist = []
  
		for(let i=0;i<self.Nontline.length;i++){
		  deflRollist.push(self.Nontline[i] - 10)
		}
  
		self.Nontline = deflRollist
  
		self.setpo = []
  
	  },
	  get_cursor_x_position(e){
		var posx = 0;
		if (! e) {
		  e = window.event;
		}
		if (e.offsetX || e.offsetY) {
		  posx = e.offsetX;
		}
		return posx;
	  },
  
	  graduation_title(datetime){
		if (
		  datetime.getHours() == 0 &&
		  datetime.getMinutes() == 0 &&
		  datetime.getMilliseconds() == 0
		) {
		  return (
			("0" + datetime.getDate().toString()).substr(-2) +"." +("0" + (datetime.getMonth() + 1).toString()).substr(-2) +"." +datetime.getFullYear()
		  );
		}
		return (
		  datetime.getHours() +":" + ("0" + datetime.getMinutes().toString()).substr(-2)
		);
	  },
	  setMStime(datetime){
		let Min = datetime.getMinutes()
		let S = datetime.getSeconds()
		Min = Min < 10 ? "0" + Min : Min;
		S = S < 10 ? "0" + S : S;
  
		return Min + ":" + S
  
	  },
  
	  changeTime (time) {
		var newTime = new Date(time);
		var year = newTime.getFullYear();
		var month = newTime.getMonth() + 1;
		if(month < 10){
			var month = "0" + month;
		}
		var date = newTime.getDate();
	  if (date < 10) {
			var date = "0" + date;
		} 
		var hour = newTime.getHours();
		if (hour < 10) {
			var hour = "0" + hour;
		}
		var minute = newTime.getMinutes();
		if (minute < 10) {
			var minute = "0" + minute;
		}
		var second = newTime.getSeconds();
		if (second < 10) {
			var second = "0" + second;
		}
		return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
	  },
  
	  ms_to_next_step(timestamp, step) {
		var remainder = timestamp % step;
		return remainder ? step - remainder : 0;
	  },
  
	  fooList(){
		const self = this
		let deflist = []
		let andTime = (self.hours_per_ruler / 2)*3600*1000
		let Purl = ''
		let audio = ''
		let setTimes = 0;
		for(let i=0;i<self.timecell.length;i++){
		  deflist.push(self.timecell[i].beginTime - andTime)
		}
		deflist.sort((res,bat)=>{
		  return Math.abs(res - self.start_timestamp) - Math.abs(bat - self.start_timestamp)
		})
  
		let aa = 0
		for(let i=0;i<self.timecell.length;i++){
  
		  if(self.start_timestamp >= self.timecell[i].beginTime - andTime && self.start_timestamp < self.timecell[i].endTime - andTime){
			aa = 1
			self.defPrx = self.Pxt
			break
		  }else{
			
			if(deflist[0] + andTime == self.timecell[i].beginTime){
  
				if(self.start_timestamp + (self.hours_per_ruler*3600*1000)/2 > self.timecell[i].endTime && i < self.timecell.length - 1){
				  if(self.timecell[i + 1].url == '' || self.timecell[i + 1].url == undefined){
					Purl = self.timecell[i + 1].wav_info[0]
				  }else{
					Purl = self.timecell[i + 1].url
				  }
				  audio = self.timecell[i + 1].wav_info[0]
				  self.defnums = i + 1
  
				  self.setDataValue(i + 1)
				  setTimes = self.timecell[i + 1].beginTime - andTime
  
				}else{
				  if(self.timecell[i].url == '' || self.timecell[i].url == undefined){
					Purl = self.timecell[i].wav_info[0]
				  }else{
					Purl = self.timecell[i].url
				  }
				  
				  audio = self.timecell[i].wav_info[0]
				  self.defnums = i
				  self.setDataValue(i)
				  setTimes = deflist[0]
				}
				
			  
			}
			self.defPrx = null
			aa = 2
		  }
		}
  
		setTimeout(()=>{
		  if(aa == 1){
			self.set_time_to_middle(self.returnTime,'1');
		  }else if(aa == 2){
			self.set_time_to_middle(self.returnTime,'2',Purl,setTimes,audio);
		  }
		},100)
  
	  },
  
	  setDataValue(i){
		const self = this
		self.showid = self.timecell[i].id
		self.meddle_pos = self.timecell[i].meddle_pos
		if(self.timecell[i].freqs_frame == null || self.timecell[i].freqs_frame == undefined){
		}else{
		  self.rotateBar = Object.values(self.timecell[i].freqs_frame)    
		}
  
		
		self.Bars = self.timecell[i].db_frame
  
		self.defKey = 0
		//当前视频数据
		self.lock_position_frame = self.timecell[i].lock_position_frame
		setTimeout(()=>{
		  self.Sevent = self.timecell[i].eventLabelCn
		},20)
			  
		self.Perc = self.timecell[i].eventProb
  
	  },
  
	  //让中心点跳到某个位置
	  set_time_to_middle(time,bool,Purl,tyTime,audio){
		const self = this
		self.clearCanvas();
		if(bool == '1'){
		  self.start_timestamp = time;
		}else{
		  clearInterval(self.timest)
		  self.start_timestamp = tyTime
		  self.getdplayers.switchVideo({
			url:Purl
		  })
		  self.barStatic = 0
		  self.urls = audio
		  self.videoUrl = Purl
		}
  
		self.init(self.start_timestamp,self.timecell)
	  },
  
	  clearDB(){
		const self = this
		self.DBtext = 0
		self.maxDB = 0
		self.defNum = 0
		self.Perc = ''
	  },
  
	  async getDBtext(){
		  const self = this         
		  if(Math.max(...self.Bars) == -Infinity || Math.max(...self.Bars) == Infinity){
			self.maxDB = 0
		  }else{
			self.maxDB = Math.max(...self.Bars)    
		  }
		  
		  for(let i=self.defNum;i<self.Bars.length;i++){
			  self.DBtext = self.Bars[i]    
			  if(self.barStatic === 0){
				  self.defNum = i
				  break;
			  }else{
				  await self.seep(28)
			  }
		  }
	  },
	  
	  seep(num){
		const self = this
		return new Promise((resolve,reject)=>{
		  setTimeout(()=>{
			resolve(1)
		  },num)
		})
	  },
  
	  clearCanvas(){
		const self = this
		// console.log('清除');
		self.ctx.clearRect(0,0,self.canvansW,self.canVansH);
	  },
  
	  TimeListSTY(index){
		const self = this

		console.log(index)

		console.log(self.setpo[index])

		console.log(self.canvansW)
  
		// if(self.setpo[index] <= 0 || self.setpo[index] > self.canvansW*2){
		//   return `display:none;`  
		// }else{
		//   return `left:${self.setpo[index] - self.defVal}px`
		//   // return `left:${self.setpo[index]}px`
		// }      
	  },
	},
  };
  </script>
  
<style>
.time_con  .dplayer-controller {
	z-index: 999!important;
}
 
</style>
  <style lang='scss' scoped>
  .vocPrint{
	height: calc(100% - 80px);
  }
  
  $sel_color:#188cf8;
  $text_yellow:#fbba40;
  
  [class^=el-icon-arrow]{
	font-size: 0.13rem;
	cursor: pointer;
  }
  .time_con{
	height: 100%;
	width: 100%;
	background: #ededed;
	overflow: hidden;
	position: relative;
  }
  
  .screen_fl_po{
	width: 100vw;
	position: relative;
	text-align: left;
	margin-top: 1%;
	.allScreen{
	  position: absolute;
	  right: 1%;
	  background: #4c4c4c;
	  width: 20%;
	  z-index: 667;
	  height: 5vmin;
	  line-height: 5vmin;
	  .AllScreen{
		cursor: pointer;
		display: inline-block;
	  }
	  .demonstration{
		width: 100%;
		color: #fff;
		display: inline-block;
		text-indent: 6vmin;
		cursor: pointer;
		.icon{
		  position: absolute;
		  right: 3vmin;
		  i{
			font-size: 2vmin;
		  }
		}
	  }
	  .AllScreenList{
		  background: #ececec;
		  z-index: 667;
		  border: 0.1vmin solid #9c9c9c;
		  /deep/.el-select,.el-cascader{
			width: 58%;
		  }
		  /deep/ .el-input__inner{
			width: 100%;
			height: 3vmin !important;
		  } 
		  .screen_fl{
			width: 47%;
			padding-left: 2%;
			display: inline-block;
		  }
		  
		  .el-input{
			width: 10vmin;
		  }
		  /deep/ .el-button{
			width: 10vmin;
			height: 3vmin;
			padding: 0;
			font-size: 1vmin;
			margin-top: 1vmin;
		  }
		  .up_fl_text{
			color: red;
			font-size: 1vmin;
			margin-left: 2vmin;
		  }
		  
		  .Cscreen_poi{
			width: 100%;
			.input_text{
			  width: 40%;
			  border: none;
			  height: 3vmin;
			  border: 0.1vmin solid #dcdfe6;
			  text-indent: 1vmin;
			  border-radius: 0.2vmin;
			  outline: none;
			}
			.up_btn{
			  width: 18%;
			  margin-left: 2%;
			  height: 3vmin;
			  .but_text{
				font-size: 1vmin;
			  }
			}
			
		  }
  
		  .Cscreen_len{
			width: 100%;
			.input_text_len{
			  width: 56%;
			  border: none;
			  border: 0.1% solid #dcdfe6;
			  border-radius: 0.1%;
			  height: 3vmin;
			  text-indent: 1vmin;
			}
		  }
		  .screen_fl_len{
			width: 81%;
			.up_btn_cl{
			  width: 18%;
			  position: absolute;
			  margin-left: 2%;
			}
		  }
  
		  .screen_fl_N{
			width: 90%;
			/deep/ .el-input{
			  width: 82%;
			}
		  }
  
	  }
	}
	.screen_url{
	  position: absolute;
	  left: 2vmin;
	  top: 1.3vmin;
	  width: 2vmin;
	  height: 2vmin;
	}
	
	.screenL{
	  /deep/ .el-input__inner{
		// display: none;
		background: #4c4c4c;
		border: none;
		height: 4vmin;
		font-size: 0px;
		width: 25vmin;
	  }
	  /deep/ .el-input__icon{
		// display: none;
		position:absolute;
		top: -0.5vmin;
		left: 5vmin;
		display: inline-block;
		.el-icon-arrow-up:before{
		  width: 1vmin;
		  display: inline-block;
		}
	  }
	}
	.aScreen{
	  border: none;
	}
	.screen_fl_bott,.screen_fl_top{
	  margin-top: 1vmin;
	}
	.all_screen_fl{
	  position: absolute;
	  background: #fbfbfb;
	  width: 18%;
	  right: 1%;
	  top: 4.5vmin;
	  padding: 0.7% 1%;
	  text-align: left;
	  z-index: 666;
	  .time_screen{
		display: inline-block;
		margin-left: 3%;
	  }
	  .screen_fl_time{
		padding-left: 2%;
		display: inline-block;
		width: 53%;
		/deep/.el-input__inner,.el-input{
		  width: 100%;
		}
	  }
  
	  .showid_audit{
		width: 20%;
		display: inline-block;
		margin-left: 5%;
		.showid_audit_btn{
		  width: 100%;
		  cursor: pointer;
		  outline: none;
		  font-size: 1.4vmin;
		  background: #409eff;
		  color: #fff;
		  border: none;
		  border-radius: 0.3vmin;
		  padding: 1vmin 0;
		}
		.audit_but_text{
		  font-size: 2vmin;
		}
	  }
	}
  }
  
  .classify{
	position: absolute;
	height: 50vmin;
	left: 0vmin;
	top:65vmin;
	text-align: center;
	/deep/ .el-table .el-table__cell{
		padding: 0;
		text-align: center;
	  }
	.color_fl{
	  margin-top: 0.4vmin;
	  width: 5vmin;
	  height: 2vmin;
	  display: inline-block;
	}
  }
  
  .audit_but{
	position: absolute;
	top: 1vmin;
	right: 25%;
  
  }
  
  .timecell_table{
	position: absolute;
	height: 50vmin;
	right: 10vmin;
	top:0vmin;
	text-align: center;
	  /deep/ .el-table .el-table__cell{
		padding: 0;
		text-align: center;
	  }
	  .el-button{
		padding: 0;
	  }
  }
  .tisp_time{
	width: 95%;
	height: 5%;
	left: 2%;
	position: relative;
	top: 1%;
	.tisp_fl_text{
	  width: 10%;
	  padding:0.2% 0;
	  box-shadow: 0 0.3vmin 5px rgba(143, 143, 143,.5);
	  background-image: linear-gradient(rgba(116, 196, 247,1),rgba(42, 166, 244,1));
	  display: inline-block;
	  position: absolute;
	  left: 50%;
	  transform: translateX(-50%);
	  border-radius:20px;
	  color: #fff;
	  justify-content: center;
	  .tisp_btn{
		font-size: 1.5vmin;
	  }
	  [class^=el-icon-caret-bottom]{
		position: absolute;
		color: #2aa6f4;
		top: 72%;
		left: 50%;
		transform: translateX(-50%);
		font-size: 2vmin;
	  }
	}
	.tisp_fl_D{
	  width: 10%;
	  padding:0.2% 0;
	  box-shadow: 0 0.3vmin 5px rgba(143, 143, 143,.5);
	  background-image: linear-gradient(rgba(116, 196, 247,1),rgba(42, 166, 244,1));
	  display: inline-block;
	  position: absolute;
	  border-radius:20px;
	  color: #fff;
	  justify-content: center;
	  .tisp_btn{
		font-size: 1.5vmin;
	  }
	  [class^=el-icon-caret-bottom]{
		position: absolute;
		color: #2aa6f4;
		top: 72%;
		left: 50%;
		transform: translateX(-50%);
		font-size: 2vmin;
	  }
	}
  }
  
  .canvas_fl{
	width: 100%;
	right: 0.4%;
	position: relative;
	z-index: 66;
	margin-bottom: 0.5%;
	.canvas_fl_time{
	  width: 95%;
	  height: 90px;
	  position: relative;
	}
	.canvas_fl_S{
	  position: absolute;
	  display: inline-block;
	  width: 100%;
	  left: 0;
	  
	.prev,.Next{
	  position: absolute;
	  display: inline-block;
	  width: 1.5%;
	  padding-top:1.61%;
	  // height: 175%;
	  border: 0.1vmin solid #c1c1c1;
	  border-bottom: none;
	  background: #eaeaea;
	  z-index: 999;
	  i{
		display: inline-block;
		position: absolute;
		top: 20%;
		font-size: 2vmin;
		font-weight: bold;
	  }
	  [class^=el-icon-arrow-left]{
		left: 20%;
	  }
	  [class^=el-icon-arrow-right]{
		right:10%;
	  }
	}
	  .prev_fl{
		left: 0;
	  }
	  .Next_fl{
		right: 0;
	  }
	  .timeN,.timeS{
		position: absolute;
		display: inline-block;
		background-size: 100% 100%;
		object-fit:fill;
	  } 
	}
	.widthc{
	  width: 90%;
	  display: inline-block;
	  position: absolute;
	}
  }

  .list_fl{
	width: 95%;
	height: 15%;
	margin: 0 auto;
	text-align: left;
	position: relative;
	right: 0.4%;
	.defDl_fl{
	  width: 11.3%;
	  margin-right: 1vmin;
	  position: absolute;
	  display:inline-block;
	  .defDl_fl_cshi{
		position: relative;
		top: 0%;
		font-size: 24px;
	  }
	  .defdl_text{
		position: absolute;
		font-weight:bold;
		color:#c0e3e4;
		width: 10vmin;
		border: 0.2vmin solid #000;
		background: #44c3c5;
		text-align: center;
		font-size: 1.5vmin;
		border-top-left-radius: 1vmin;
		z-index: 67;
	  }
	}
	
  .video_url_card{
	width: 90%;
	height: 12vmin;
	margin-right: 1vmin;
	object-fit:fill;
	border-radius: 1vmin;
	cursor: pointer;
	position: absolute;
	z-index: 66;
  }
  .video_url_card_text{
	width: 90%;
	height: 12vmin;
	position: absolute;
	font-size: 3vmin;
	text-align: center;
	line-height: 12vmin;
	border-radius: 1vmin;
	cursor: pointer;
	z-index: 66;
	background:#000;
	color:#31d1d4;
  }
	.video_url_card_shadow,.video_url_card_shadowtow{
	  display: inline-block;
	  position: absolute;
	  width: 89%;
	  
	  border-radius: 0.5vmin;
	  left: 0;
	}
	.video_url_card_shadow{
	  height: 10.5vmin;
	  top: 0.9vmin;
	  box-shadow: 0.7vmin 0vmin 0vmin rgba(182, 182, 182,1);
	  z-index: 3;
	}
	.video_url_card_shadowtow{
	  height: 8.5vmin;
	  top: 1.8vmin;
	  box-shadow: 1.2vmin 0vmin 0vmin rgba(205, 206, 207,1);
	}
	  
  
  }
  
  .video_fl{
	width: 50.8%;
	height: 62%;
	left: 22%;
	position: relative;
	// transform:translateX(-50%);
	margin: 1%;
	.video_content{
	  width: 100%;
	  height: 100%;
	  object-fit:fill;
	}
	
	.schibtn{
	  position: absolute;
	  top: 0;
	  left: 0;
	  outline: none;
	  // cursor: pointer;
	}
	.video_url_fl{
	  width: 100%;
	  height: 100%;
	  background: #000;
	  position: relative;
	  .video_url_text{
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
		color: #fff;
		font-size: 6vmin;
	  }
	}
  }
  .rulers_fl{
	width: 1750px;
	height: 200px;
  }
  
  
  
  
  .listShow{
	.icons{
	  cursor: pointer;
	}
	.viderlist{
	  height: 11vmin;
	  overflow-y: auto;
	  text-align: left;
	.videoItem{
	  width: 9%;
	  z-index: 66;
	  height: 90%;
	  display: inline-block;
	  margin:2vmin 1.5vmin 0vmin 0vmin;
	  position: relative;
	  left: 1%;
	  cursor: pointer;
  
	.duration_text{
	  position: absolute;
	  top: 0%;
	  right: 2%;
	  color: #fff;
	  font-size: 2vmin;
	}
	.video_play_Text{
	  width: 100%;
	  height: 100%;
	  border-radius: 1vmin;
	  padding: 0vmin;
	  font-size: 2vmin;
	  background: #000;
	  text-align: center;
	  line-height: 10vmin;
	  color:#31d1d4;
	}
	.video_play{
	  width: 100%;
	  height: 100%;
	  object-fit:fill;
	  border-radius: 1vmin;
	  padding: 0vmin;
	}
	.video_play_bor{
	  border: 0.4vmin solid #b7daff;
	}
  } 
  }
  }
  
  
  .audiofer_fl{
	position: absolute;
	right: 8%;
	top: 8%;
  }
  
  .map_fl{
	position: absolute;
	top: 15vmin;
	right: 1%;
	width: 20%;
	height: 81%;
	.map_core{
	  width: 100%;
	  height: 30%;
	  background-color: #fbfbfa;
	  padding-top: 15px;
	  .bm_view{
		width: 90%;
		height: 90%;
		margin: 0 auto;
	  }
	}
  
  }
  
  
  .tisp_fl{
	.tisp_fl_bg{
	  position: absolute;
	  text-align: left;
	  top: 2vmin;
	  left: 1%;
	  // z-index: 99;
	  background-color: #fbfbfa;
	  width: 17.5%;
	  padding: 0.5% 1.4%;
	  color:#909090;
	  .text_bg{
		margin: 2.5% 0;
		.text_bg_center{
		  width: 76%;
		  position: absolute;
		  display: inline-block;
		}
		.Sevent_text{
		  display: inline-block;
		  overflow: hidden;
		  text-overflow:ellipsis; 
		  white-space: nowrap;
		  width:70%;
		}
	  }
	  .shi_t{
		text-indent: 3.3vmin;
		display: inline-block;
	  }
	  .text_bor{
		display: inline-block;
		height: 5vmin;
		// border-bottom: 0.3vmin solid #31d1d4;
		margin-left: 2vmin;
	  }
	  .text_le{
		letter-spacing:3.5vmin;
	  }
	  .text_color{
		color: #31d1d4;
		display: inline-block;
		text-indent:2vmin;
		.text_font{
		  font-size: 5vmin;
		  padding-right: 2vmin;
		}
		.text_wilte{
		  color: #909090;
		}
	  }
	}
  }
  
  
  .sample{
	width: 120px;
	height: 40px;
	// background: rgba(0,0,0,0.5);
	position: absolute;
  
	#circPo{
	  // background-color: rgba(255,255,255,0.5);
	  position: absolute;
	  top: 50%;
	  left: 50%;
	  transform: translate(-50%,-50%);
	  // transform: rotate(180deg);
	  // top: -7.5vmin;
	  // left: -7vmin;
	}
  
  }

  .video_fl .dplayer-controller .dplayer-bar-wrap{
	  z-index: 999;
  }
  </style>


// WEBPACK FOOTER //
// VoiceprintRecognition.vue?4945a586